import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import * as Sentry from "@sentry/angular";
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DEV_ENV_NAME } from './constants/env';
import { AuthService } from './services/auth.service';
var HttpConfigInterceptor = /** @class */ (function () {
    function HttpConfigInterceptor(router, injector) {
        this.router = router;
        this.injector = injector;
    }
    Object.defineProperty(HttpConfigInterceptor.prototype, "authService", {
        get: function () {
            return this.injector.get(AuthService);
        },
        enumerable: true,
        configurable: true
    });
    HttpConfigInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        return next.handle(request).pipe(catchError(function (err) {
            var error;
            if (err.error) {
                error = err.error.message || err.error.detail;
            }
            else {
                error = err.statusText || err;
            }
            return throwError(error);
        }))
            .pipe(map(function (event) {
            if (event instanceof HttpResponse) {
                if (event.body.responseCode == 401) {
                    // Requests tagged X-Background-Request (e.g. CallService's automatic, native
                    // call-triggered lead lookup) fire invisibly to the user, often alongside their
                    // own navigation on completion. Forcing navigation to /auth/login here would race
                    // with that, leaving the app on a blank screen (issue #313). Any future
                    // fire-and-forget/background request can opt out the same way.
                    if (request.headers.has('X-Background-Request')) {
                        return event;
                    }
                    var currentRoute = _this.router.url || window.location.hash.replace(/^#/, '');
                    if (currentRoute && currentRoute.indexOf('/auth/') !== 0) {
                        _this.authService.rememberOidcRetryRoute(currentRoute);
                    }
                    _this.router.navigateByUrl("/auth/login");
                }
                else if (event.body.responseCode == 500) {
                    if (event.body.error) {
                        var newError_1 = new Error(event.body.error);
                        if (environment.envName === DEV_ENV_NAME) {
                            console.error("TSTERR intercept", newError_1);
                        }
                        else {
                            console.error(newError_1);
                        }
                        Sentry.withScope(function (scope) {
                            scope.setExtra("errorExtraData", newError_1);
                            scope.setExtra("handlerSource", "interceptor");
                            if (environment.envName !== DEV_ENV_NAME) {
                                var eventId = Sentry.captureException(newError_1);
                            }
                        });
                        // Sentry.showReportDialog({
                        //     eventId: eventId,
                        // });
                    }
                }
                else if (event.status !== 200) {
                    console.error("HTTP interceptor error", event.body.error || event);
                }
            }
            return event;
        }));
    };
    return HttpConfigInterceptor;
}());
export { HttpConfigInterceptor };
